import Erc20_data_source_class from '../datasource/erc20_data_source.js'

class Get_is_erc20_transfer_allowed_for_amount_from_address_for_user_account_usecase {
  constructor () {
    this.Erc20DataSource = new Erc20_data_source_class()
  }

  async execute (erc20TokenContractAddress, spenderAddress, amount) {
    return this.Erc20DataSource.isTokenTransferApprovedForAmount(
      erc20TokenContractAddress,
      spenderAddress,
      amount
    )
  }
}

export default Get_is_erc20_transfer_allowed_for_amount_from_address_for_user_account_usecase
